import React from 'react';

// Composant pour afficher le code réglementaire
const CodeReglementaire: React.FC = () => {
    return <div className='code-reglementaire'>FR-VAX-00448 - Janvier 2026</div>;
};

export default CodeReglementaire;
